export const CLEAR_STORAGE_REQUEST_CONTEXT = 'CLEAR_STORAGE_REQUEST_CONTEXT';
export const CLEAR_CREATE_STORAGE_REQUEST_CONTEXT =
  'CLEAR_CREATE_STORAGE_REQUEST_CONTEXT';

export const GET_STORAGE_REQUESTS_REQUEST = 'GET_STORAGE_REQUESTS_REQUEST';
export const GET_STORAGE_REQUESTS_SUCCESS = 'GET_STORAGE_REQUESTS_SUCCESS';
export const GET_STORAGE_REQUESTS_FAILURE = 'GET_STORAGE_REQUESTS_FAILURE';

export const CREATE_STORAGE_REQUEST_REQUEST = 'CREATE_STORAGE_REQUEST_REQUEST';
export const CREATE_STORAGE_REQUEST_SUCCESS = 'CREATE_STORAGE_REQUEST_SUCCESS';
export const CREATE_STORAGE_REQUEST_FAILURE = 'CREATE_STORAGE_REQUEST_FAILURE';

export const ARCHIVE_STORAGE_REQUEST_REQUEST = 'ARCHIVE_STORAGE_REQUEST_REQUEST';
export const ARCHIVE_STORAGE_REQUEST_SUCCESS = 'ARCHIVE_STORAGE_REQUEST_SUCCESS';
export const ARCHIVE_STORAGE_REQUEST_FAILURE = 'ARCHIVE_STORAGE_REQUEST_FAILURE';

export const GET_ARCHIVED_STORAGE_REQUESTS_REQUEST = 'ARCHIVE_STORAGE_REQUESTS_REQUEST';
export const GET_ARCHIVED_STORAGE_REQUESTS_SUCCESS =
  'GET_ARCHIVED_STORAGE_REQUESTS_SUCCESS';
export const GET_ARCHIVED_STORAGE_REQUESTS_FAILURE =
  'GET_ARCHIVED_STORAGE_REQUESTS_FAILURE';

export const ACCEPT_STORAGE_REQUEST_REQUEST = 'ACCEPT_STORAGE_REQUEST_REQUEST';
export const ACCEPT_STORAGE_REQUEST_SUCCESS = 'ACCEPT_STORAGE_REQUEST_SUCCESS';
export const ACCEPT_STORAGE_REQUEST_FAILURE = 'ACCEPT_STORAGE_REQUEST_FAILURE';

export const DECLINE_STORAGE_REQUEST_REQUEST = 'DECLINE_STORAGE_REQUEST_REQUEST';
export const DECLINE_STORAGE_REQUEST_SUCCESS = 'DECLINE_STORAGE_REQUEST_SUCCESS';
export const DECLINE_STORAGE_REQUEST_FAILURE = 'DECLINE_STORAGE_REQUEST_FAILURE';

export const CANCEL_STORAGE_REQUEST_REQUEST = 'CANCEL_STORAGE_REQUEST_REQUEST';
export const CANCEL_STORAGE_REQUEST_SUCCESS = 'CANCEL_STORAGE_REQUEST_SUCCESS';
export const CANCEL_STORAGE_REQUEST_FAILURE = 'CANCEL_STORAGE_REQUEST_FAILURE';

export const SET_STORAGE_REQUEST_TO_SEEN_REQUEST = 'SET_STORAGE_REQUEST_TO_SEEN_REQUEST';
export const SET_STORAGE_REQUEST_TO_SEEN_SUCCESS = 'SET_STORAGE_REQUEST_TO_SEEN_SUCCESS';
export const SET_STORAGE_REQUEST_TO_SEEN_FAILURE = 'SET_STORAGE_REQUEST_TO_SEEN_FAILURE';

export const ADD_STORAGE_REQUEST = 'ADD_STORAGE_REQUEST';
